// extracted by mini-css-extract-plugin
module.exports = {"containerBox":"_3i6L1","container":"CfF2P","linkContainer":"_2iOPZ","heading":"_2oRiE"};